class RestoreMessageWorkflow {
    constructor($injector) {
        this.injector = $injector;
        this.alert = this.injector.get('Alert');
        this.api = this.injector.get('$http');
        this.state = this.injector.get('$state');
        this.translate = this.injector.get('$translate');

        this.key = 'restore-message';
        this.title = this.translate.instant('general.verbs.restore');
        this.level = 'archived-highlight';
        this.icon = 'fal fa-undo';
    }

    action(message, vm) {
        const translatedValue = (path, params) => {
            return this.translate.instant(`messages.workflows.ask-to-restore-message.${path}`, params);
        };

        this.alert.animatedAlert(
            translatedValue('title'),
            translatedValue('content', { message_subject: message.subject || 'message' }),
            'attention',
            {
                confirmButtonText: translatedValue('confirm'),
                cancelButtonText: translatedValue('cancel'),
                wait: true
            }).then(() => {
            return this.api.put(`messages/${ message.id }/restore`)
                .then(() => {
                    this.state.reload();
                    if (vm.store) {
                        return vm.store.dispatch('getData');
                    }
                }, err => this.alert.handle(err));
        }, () => ({}))
    }

}

angular
    .module('festzelt-os.modules.messages')
    .factory('restoreMessage', [
        '$injector',
        ($injector) => new RestoreMessageWorkflow($injector)
    ]);




// WEBPACK FOOTER //
// ./src/app/modules/messages/workflows/details/restore.js